// S3 Url
export const IMAGE_PATH = process.env.REACT_APP_IMAGE_PATH;
export const MERCADO_PAGO_PUBLIC_KEY = process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY;

export const IMAGE_FALLBACK =
  'data:image/png;base64,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';

export const IMAGE_LOADING1 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbsAAAFYBAMAAAA4l08BAAAAJFBMVEX////q6urS0tLx8fH8/Pz5+fnt7e3i4uL29vbd3d3n5+fX19daR20aAAAE50lEQVR42u3avW8bdRjA8YtyTg0TJyoXPEZiiLy4cuO67XIRTilMQdgogiWWVYMylVdjZ3HltBgmCLSW8VJLEKMbs6DI/xzPc9ekThrfueNz+n4qdfEN/fb5vZzbOA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABSKtM4WFenxzspjLuxfq7wY9oCs0fr8zb2UlW3dlRYL8z3FX5IUd3WiVi/KD3z25rp6C4Vpmb7rc4Ks8tx6xupOTMPZicn0lcQr/I+SEvevZkozMK6VxP8LSV1n4Rx4dlyMtfX89OxNMc6vBNN3PimMhDBUbT1UtH35ezMv2dnpXtbt57vuil4WzmL27g+f8t/+8iX6dnv++Vl3X/Fi0u25uv0XPM77zSsO+1d/sT1dXrG+z4ej081sPj6R1Xftd7nHmjcePb9VR9GfZatnI7F7PnVn4Z9lgPvydIUC96efe2zvDZHOrzxs0UfS58wm3dtrH2jhQFV6TM8vTsj7Xu2eLrSV7U7vpHEjcYx31s1rmr2H1hkeKPx87jNWa1WXat9b43Ui7hHqtrnW916MryRn5RndfN1dHh/xF8d2mdzdWaT16bj1szmrYR5vfiHqtpncnV+pHV/JTxU1T6TeXc6svn+THpvq2mfxbz3O8NhwtbTs0X7LOa1h7I4i0lPaV3NYN1qpz0cDhMfq2mfwc231h62O78nPratfQbzrun0fkr+Tliv1bYt5snSHCb/T0KmVje5OH9utzvtF8tMr143eHTe1sW5t0SerE6DR+dXbVFMfq6u7OXdkLU53Fkub9tinvBTOz2tay/x3K7NvOmSefXdVE+v/kT67F187W532entGszrvsH0dn2Le6+71NGi0zN4MUyny52cA+kz+NYylc23xLU+0D57efsyvWlviTzpM5h3N5DpJb9zugPts5f3a3c6ne4tlWdxel8E3aD7KPGxrOY9sZf3dhB0p/8sl3doL29lGkyD7xIfe6B5PXt5q4FKvvb6NvMyujiDxD+4xPUHFn+uOq/TeyfpL6E/qAwGvsG8u1M5O/9OPFkq8stgndwMsjyPk06Wiuy9TYt5K+HZkrDu+hXRs5iX1bpu/HtLRuL6A5N5bji9+Is9Wyn1K32LJ4ucLXp2TuLXZqlSKZnceo6zlde+uC8Nbkn0D23mrXraF7c6V2Vtlvo9m3luXvsmftzalOGVHKMeh32LX1yyGmd168nm87TvOHZ4pX7Ral4mr33B3uLhKd9qnnMz7DuOG16pYrbOWfPCvutXH5vNpuYV7ea5XtTXu/LOazbLptem43wa9eWuaHjaKpelb9NwnZPxor73Xq8ry/RkefYs5zmPo7785b7PWk2ZXrn8tek6eTEL+7yLfe7Tl3Vl28MLd5+n7y7euztzo1O6No0PL9p9YuJ5uc3ogHlQjupaLfvDc5z7Ud5Ef9eLrpVr5XJRX/OhY9/NRrQ+ozF6UtdqNKLV6acgL9tohNML+3I5L5xe2Ndz0uBDz2vo9KL5aZ9MT/puOelw39sPp3fep9NrPHTS4vMgmOTn+rxGK5eeOtl/+Qt9Mr5NJ00yjfk+r3nopEx//7wvd8tJod2W1k3SNzkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADY9T/czL9IG3+TogAAAABJRU5ErkJggg==';
  
  
export const URL_TERMS_OF_SERVICE = 'https://www.cateperu.com/';

export const URL_PRIVACY_NOTICES = 'https://www.cateperu.com/';

export const URL_FACEBOOK = 'https://www.facebook.com/Cateperu/';

export const URL_INSTAGRAM = 'https://www.instagram.com/cateperu/';

export const URL_YOUTUBE = 'https://www.youtube.com/channel/UCeWOWsMkHBiwnKhNID6MHEg';

export const URL_PINTEREST = 'https://www.facebook.com/Cateperu/';

//export const CULQI_KEY = 'pk_test_sUxfz9fD28KanWlD';

export const CULQI_PUBLIC_KEY='pk_test_36d8732d2fa16ca1'
export const CULQI_SECRET_KEY = 'sk_test_KQEVvyK8gKqPup9U';


export const BOOLEAN_TO_NUMBER = {
  false: 0,
  true: 1,
};

export const NUMBER_TO_BOOLEAN = {
  0: false,
  1: true,
};

export const PHONE_PREFIX = [
  {
    value: '51',
    label: '+51',
  },
  {
    value: '52',
    label: '+52',
  },
  {
    value: '57',
    label: '+57',
  },
  {
    value: '593',
    label: '+593',
  },
];

export const ORDER_STATE_NAME = {
  1: 'Pendiente de pago',
  2: 'Pendiente de envió',
  3: 'Entregado',
  4: 'Reembolsado',
  409: 'Error',
};

export const ORDER_STATE_COLOR = {
  1: 'geekblue',
  2: 'red',
  3: 'green',
  4: 'purple',
  409: 'magenta',
};

export const INVOICE_ARRAY = [
  {
    value: 0,
    name: 'Boleta',
  },
  {
    value: 1,
    name: 'Factura',
  },
];

export const TIME_ARRAY = [
  {
    id: 1,
    name: '09:00:00',
  },
  {
    id: 2,
    name: '09:30:00',
  },
  {
    id: 3,
    name: '10:00:00',
  },
  {
    id: 4,
    name: '10:30:00',
  },
  {
    id: 5,
    name: '11:00:00',
  },
  {
    id: 6,
    name: '11:30:00',
  },
  {
    id: 7,
    name: '12:00:00',
  },
  {
    id: 8,
    name: '12:30:00',
  },
  {
    id: 9,
    name: '13:00:00',
  },
  {
    id: 10,
    name: '13:30:00',
  },
  {
    id: 11,
    name: '14:00:00',
  },
  {
    id: 12,
    name: '14:30:00',
  },
  {
    id: 13,
    name: '15:00:00',
  },
  {
    id: 14,
    name: '15:30:00',
  },
  {
    id: 15,
    name: '16:00:00',
  },
  {
    id: 16,
    name: '16:30:00',
  },
  {
    id: 17,
    name: '17:00:00',
  },
  {
    id: 18,
    name: '17:30:00',
  },
  {
    id: 19,
    name: '18:00:00',
  },
];

export const LOCAL_STORAGE = {
  DELIVERY_PRICE_LIST: 'delivery_price_list',
  DELIVERY_PRICE_LIST_DATE_LOADED: 'delivery_price_list_date_loaded'
}